module.exports = __webpack_public_path__ + "img/153-united-states-of-america.69055229.svg";